import { useDynamicEntityStoreContext } from '../contexts';
import SEOImageUploader from './_seo_list/SEOImageUploader';
import SEOTextArea from './_seo_list/SEOTextArea';

export default function SEOList({ isEdit }) {
  const update = useDynamicEntityStoreContext((state) => state.update);
  const updateSeo = useDynamicEntityStoreContext((state) => state.updateSeo);

  const seoTitle = useDynamicEntityStoreContext((state) => state.data.seo.title);
  const seoDescription = useDynamicEntityStoreContext((state) => state.data.seo.description);
  const seoKeywords = useDynamicEntityStoreContext((state) => state.data.seo.keywords);
  const seoCanonical = useDynamicEntityStoreContext((state) => state.data.seo.canonical);
  const seoRobots = useDynamicEntityStoreContext((state) => state.data.seo.robots);
  const seoCopyright = useDynamicEntityStoreContext((state) => state.data.seo.copyright);
  const seoAlternateHreflang = useDynamicEntityStoreContext((state) => state.data.seo.alternate.hreflang);
  const seoAlternateUrl = useDynamicEntityStoreContext((state) => state.data.seo.alternate.url);
  const seoJsonSchema = useDynamicEntityStoreContext((state) => state.data.seo.json_schema);
  const seoOpenGraphImage = useDynamicEntityStoreContext((state) => state.data.seo.open_graph.image);

  return (
    <div className="dp-seo-container">
      <div className="d-flex flex-column">
        <h3 className="mb-1">SEO</h3>
        <p className="text-muted mb-0">Configure your SEO here</p>
      </div>
      <div className="dp-seo-fields">
        <SEOTextArea
          id="seo-title"
          label="Title"
          addonLabel="Enter your title tag here."
          seo="title"
          value={seoTitle}
          onChange={(e) => updateSeo({ title: e.target.value })}
        />
        <hr />
        <SEOTextArea
          id="seo-description"
          label="Description"
          addonLabel="Enter your meta description here."
          seo="description"
          value={seoDescription}
          onChange={(e) => updateSeo({ description: e.target.value })}
        />
        <hr />
        <SEOTextArea
          id="seo-keywords"
          label="Keywords"
          addonLabel="Enter your meta keywords here."
          seo="keywords"
          value={seoKeywords}
          onChange={(e) => updateSeo({ keywords: e.target.value })}
        />
        <hr />
        <SEOTextArea
          id="seo-canonical"
          label="Canonical"
          addonLabel="Enter your canonical URL here."
          seo="canonical"
          value={seoCanonical}
          onChange={(e) => updateSeo({ canonical: e.target.value })}
        />
        <hr />
        <SEOTextArea
          id="seo-robots"
          label="Robots"
          addonLabel="Enter your robots meta tag here."
          seo="robots"
          value={seoRobots}
          onChange={(e) => updateSeo({ robots: e.target.value })}
        />
        <hr />
        <SEOTextArea
          id="seo-copyright"
          label="Copyright"
          addonLabel="Enter your copyright information here."
          seo="copyright"
          value={seoCopyright}
          onChange={(e) => updateSeo({ copyright: e.target.value })}
        />
        <hr />
        <SEOTextArea
          id="seo-alternate-hreflang"
          label="Alternate HREFLANG"
          addonLabel="Enter a one-off alternate HREFLANG here."
          seo="alternate.hreflang"
          value={seoAlternateHreflang}
          onChange={(e) => updateSeo({ 'alternate.hreflang': e.target.value })}
        />
        <SEOTextArea
          id="seo-alternate-url"
          label="Alternate URL"
          addonLabel="Enter a one-off alternate URL here."
          seo="alternate.url"
          value={seoAlternateUrl}
          onChange={(e) => updateSeo({ 'alternate.url': e.target.value })}
        />
        <div className="d-flex gap-2 align-items-center mb-3">
          <button className="btn btn-secondary btn-sm" onClick={() => update({ activePane: 5 })} disabled={!isEdit}>
            More Alternates
          </button>
          {!isEdit && <span className="text-muted fs-5">You need to save this page first.</span>}
        </div>
        <hr />
        <SEOTextArea
          id="seo-json-schema"
          label="JSON Schema"
          addonLabel="Enter your JSON-LD schema here."
          seo="json_schema"
          value={seoJsonSchema}
          onChange={(e) => updateSeo({ json_schema: e.target.value })}
        />
        <hr />
        <h4>Open Graph</h4>
        <SEOImageUploader
          id="seo-open-graph-image"
          label="Image"
          seo="open_graph.image"
          addonLabel="Upload / Select your OG image and enter the alt text for this page."
          value={seoOpenGraphImage}
          onChange={(value) => updateSeo({ 'open_graph.image': value })}
        />
      </div>
    </div>
  );
}
